// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Title":"Title-uw4mvmus9qpmt628597f4zsjbad2xzkazq2n7rmyv5gakfd85tbn1r78xkyk41pg3jswjuqb1htfsd6wj2k58u69den6nxtgexdn59","loading":"loading-2ue6c2usa7hu2fmpeawqpqzc5du5kytt8q69s1xk8fptdh7tj4rnrktunshj75pxgn7bf6rnd1uybgzmjaza4nacu3fajwam7jkwec7","pulse":"pulse-4yfwhuatvp1x6k7kckzft645ydmuepabxhwnknhgd4v5pgtwbawhe2h767j8hrek4w1d8t1m91b1xsx3yjrtgy6crqcc4n36n1r5e52"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Layout/components/Title/Title.module.scss
// module id = 1118
// module chunks = 0